import React from 'react'
import HomeTyping from '../Contents/HomeTyping';
import Loader from '../Contents/Loader';


const Home = () => {
  return (
    <div>
      <Loader/>
      <HomeTyping/>
    </div>
  )
}

export default Home;
